module.exports = __webpack_public_path__ + "static/media/Zscaler_BrandAssets_LogoLockup_White.a532748e.png";